import { render, staticRenderFns } from "./tail-loader.vue?vue&type=template&id=4697e1d3"
import script from "./tail-loader.vue?vue&type=script&lang=js"
export * from "./tail-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports